/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { faLongArrowRight } from '@fortawesome/pro-solid-svg-icons'
import Button from '../../components/form/Button'
import Dropdown from '../../components/form/Dropdown'

const QuestionDropdown = ({ question, onContinue, buttonStyle }) => {
  const [selectedValue, setSelectedValue] = useState(null)

  const [dropdownComp, setDropdownComp] = useState(null)

  const handleContinue = () => {
    console.log(selectedValue)
    onContinue(selectedValue)
  }

  // new question of the same type -> reset
  useEffect(() => {
    const choices = question.options.map((option, i) => {
      return { name: option.value, value: i }
    })
    setDropdownComp(
      <Dropdown
        action={(e) => {
          // console.log(e)
          setSelectedValue(e[1][0])
        }}
        data={choices}
        default={['', '']}
        className="inpt-lrg-2"
        placeholder="Select..."
        name="question-dropdown"
      />
    )
    setSelectedValue(null)
  }, [question])

  return (
    <>
      {dropdownComp}

      <div className="pt-medium">
        <Button
          label=""
          icon={faLongArrowRight}
          customCSS={{ fontSize: '1.5em', margin: 'auto', ...buttonStyle }}
          clickHandler={handleContinue}
          disabled={!selectedValue}
        />
      </div>
    </>
  )
}

QuestionDropdown.defaultProps = {
  buttonStyle: {},
}

QuestionDropdown.propTypes = {
  question: PropTypes.shape({
    options: PropTypes.array.isRequired,
    logic: PropTypes.array.isRequired,
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  buttonStyle: PropTypes.object,
}

export default QuestionDropdown
